import translate from "./locales";

export const COLOR_PALETTES = [
  {
    color_6: "#165827",
    color_5: "#21891F",
    color_4: "#3ECF6E",
    color_3: "#6DE19B",
    color_2: "#C3F0C7",
    color_1: "#EEF7EE",
    color_light_1: "#FFFBF1",
    color_light_2: "#FDEDCE",
    color_black: "#000000",
    color_white: "#FFFFFF",
  },
  {
    color_6: "#FF9600",
    color_5: "#B17500",
    color_4: "#FFBE32",
    color_3: "#FFBE32",
    color_2: "#FFE682",
    color_1: "#FFFBF1",
    color_light_1: "#FDEDCE",
    color_light_2: "#FFFBF1",
    color_black: "#000000",
    color_white: "#FFFFFF",
  },
  {
    color_6: "#E62323",
    color_5: "#960032",
    color_4: "#FF78A0",
    color_3: "#FF78A0",
    color_2: "#FFBFC3",
    color_1: "#FFFBF1",
    color_light_1: "#FFF2F6",
    color_light_2: "#FDEDCE",
    color_black: "#000000",
    color_white: "#FFFFFF",
  },
  {
    color_6: "#002B6C",
    color_5: "#011F49",
    color_4: "#005AEB",
    color_3: "#00AAFF",
    color_2: "#D0EAFF",
    color_1: "#E6F5FF",
    color_light_1: "#FDEDCE",
    color_light_2: "#FFFBF1",
    color_black: "#000000",
    color_white: "#FFFFFF",
  },
];

export const IMAGE_OPTIONS = ["a", "b", "c", "d"];

export function formToOverrides(form) {
  const overrides = {
    ...COLOR_PALETTES[form.color],
    title: form.title ?? " ",
    party_1: form.party_1 ?? " ",
    party_2: form.party_2 ?? " ",
    cause: form.cause[0] ? translate(form.cause[0]) : "",
    tactic_1: form.tactic_1 ?? "",
    tactic_2: form.tactic_2 ?? "",
    tactic_3: form.tactic_3 ?? "",
    deaths: translate("poster.deaths", { number: form.deaths ?? 0 }),
    injured: translate("poster.injured", { number: form.injured ?? 0 }),
    number_victims: translate("poster.victims", {
      number: form.number_victims ?? 0,
    }),
    damage_choice_1: form.damage[0]
      ? translate(["poster", "damage", form.damage[0]])
      : "",
    damage_choice_2: form.damage[1]
      ? translate(["poster", "damage", form.damage[1]])
      : "",
    damage_choice_3: form.damage[2]
      ? translate(["poster", "damage", form.damage[2]])
      : "",
    damage_choice_4: form.damage[3]
      ? translate(["poster", "damage", form.damage[3]])
      : "",
    disadvantage: translate("poster.disadvantage", {
      disadvantage: form.disadvantage ?? "",
    }),
    reason_disadvantage: translate("poster.reason_disadvantage", {
      reason_disadvantage: form.reason_disadvantage ?? "",
    }),
    demand: translate("poster.demand", { demand: form.demand ?? "" }),
    assessment:
      form.assessment[0] === "true"
        ? translate("poster.assessment-yes")
        : translate("poster.assessment-no"),
    answer_distinction:
      form.distinction[0] === "true"
        ? translate("poster.answer-yes")
        : translate("poster.answer-no"),
    answer_distinction_icon: form.distinction[0] === "true" ? "check" : "x",
    answer_proportion:
      form.proportion[0] === "true"
        ? translate("poster.answer-yes")
        : translate("poster.answer-no"),
    answer_proportion_icon: form.proportion[0] === "true" ? "check" : "x",
    answer_precaution:
      form.precaution[0] === "true"
        ? translate("poster.answer-yes")
        : translate("poster.answer-no"),
    answer_precaution_icon: form.precaution[0] === "true" ? "check" : "x",
    country_1: form.country_1 ?? "",
    support_1: translate("poster.support", { support: form.support_1 ?? "" }),
    support_how_1: translate("poster.support_how", {
      support_how: form.support_how_1 ?? "",
    }),
    country_2: form.country_2 ?? "",
    support_2: translate("poster.support", { support: form.support_2 ?? "" }),
    support_how_2: translate("poster.support_how", {
      support_how: form.support_how_2 ?? "",
    }),
    background_image_1: form.background_image_1,
    background_image_2: form.background_image_2,
  };
  return overrides;
}

function damagesToSentence(values) {
  const length = values.length;
  if (length === 1) return values.at(0);

  return values.reduce((str, item, index) => {
    str += translate([
      "poster",
      "alt_description",
      index === length - 1 ? "joiner" : "last_join",
    ]);
    str += translate(["poster", "damage", item]);
    return str;
  }, "");
}

export function generateFallbackText(page, data) {
  const intro = translate(["poster", "alt_description", "intro"], {
    currentPage: page,
  });
  let interpolations;
  switch (page) {
    case 1:
      interpolations = {
        title: data.title,
        partyOne: data.party_1,
        partyTwo: data.party_2,
        cause: translate(data.cause.at(0)),
      };
      break;
    case 2:
      interpolations = {
        tactic_1: data.tactic_1,
        tactic_2: data.tactic_2,
        tactic_3: data.tactic_3,
        deaths: data.deaths,
        injured: data.injured,
        damages: damagesToSentence(data.damage),
      };
      break;
    case 3:
      interpolations = {
        partyName: data.disadvantage,
        reason: data.reason_disadvantage,
        demands: data.demand,
      };
      break;
    case 4:
      interpolations = {
        assessment:
          data.assessment[0] === "true"
            ? translate("poster.assessment-yes")
            : translate("poster.assessment-no"),
        distinction: translate([
          "poster",
          "alt_description",
          "principle",
          data.distinction[0] === "true" ? "followed" : "notFollowed",
        ]),
        proportion: translate([
          "poster",
          "alt_description",
          "principle",
          data.proportion[0] === "true" ? "followed" : "notFollowed",
        ]),
        precaution: translate([
          "poster",
          "alt_description",
          "principle",
          data.precaution[0] === "true" ? "followed" : "notFollowed",
        ]),
      };
      break;
    case 5:
      interpolations = {
        partyOne: data.country_1,
        partyTwo: data.country_2,
        supportOne: data.support_1,
        supportTwo: data.support_2,
        supportHowOne: data.support_how_1,
        supportHowTwo: data.support_how_2,
      };
      break;
    default:
      throw `Unexpected page ${page}`;
  }

  return `${intro} ${translate(["poster", "alt_description", `page_${page}`], interpolations)}`;
}
